import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const defaultCheckODBalToGLFields = {
  matchAmtFlag: '',
  date: '',
  odAmt: '',
  fundAmt: '',
  bankAmt: '',
};

export const checkODBalanceToGL = {
  namespaced: true,
  actions: {
    async odBalToGLGatherInformation({ commit, dispatch }, { criteria }) {
      let results;
      const gqlfields = defaultCheckODBalToGLFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query
                    odBalToGLGatherInformation ($criteria:odBalToGLGatherInfoCriteriaType) {
                    odBalToGLGatherInformation(criteria: $criteria){
                    ${fieldsToGqlString(gqlfields)}
                    },
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.odBalToGLGatherInformation || {}) : {};
        // console.info(results.data, 'res');
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There is a problem while collecting gather information.', { root: true });
      }
      return null;
    },
  },
};
export default checkODBalanceToGL;
